import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { useUser } from "../../utils/hooks";
import { setAuthRedirectUrl } from "../../utils/authUrl";
const ActivateConnectedDeviceView = React.lazy(() => import("../../components/organisms/activate-connected-device"));
const getProps = (data) => {
    return data;
};
const ActivateConnectedDevice = ({ environment, }) => {
    const { isAnonymous } = useUser();
    const baseURL = `${environment.authService.protocol}://${environment.authService.domain}`;
    const returnUrlLinkTv = window.location.origin + "/activate";
    const authRedirect = setAuthRedirectUrl(returnUrlLinkTv);
    const auth = `${baseURL}/login?low=OTPLogin&header=likeOrWatch&returnUrl=${authRedirect}`;
    return isAnonymous ? (React.createElement(React.Fragment, null, window.location.replace(auth))) : (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(ActivateConnectedDeviceView, { read: environment })));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, ActivateConnectedDevice);

